import { render } from "./AttendanceDetails.vue?vue&type=template&id=8891b13c"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__